<template>
<div class="home">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Completed Jobs</h1><small>(Jobs created before July 2023 will only shown in Archive) </small>
        <!--<a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i class="fas fa-download fa-sm text-white-50"></i> Generate Report</a>-->
    </div>

    <job-table :statusStep="statusStep"></job-table>
</div>
</template>

<script>
import JobTable from "@/components/JobTable";

export default {
    name: "CompletedJobs",
    components: {
        JobTable,
    },
    data() {
        return {
            statusStep: "Completed",
        };
    },
    computed: {

    },
    methods: {

    },
};
</script>

<style>
</style>
